import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { get } from 'lodash';
import React from 'react';
import { addToken } from '../../../http/TokensApi';

const initialAddTokenFormData = Object.freeze({
  name: '',
  symbol: '',
  address: '',
  decimals: '',
  iconUrl: '',
});

export default function AddTokenDialog({
  open,
  onClose,
  onTokenAdded,
  setErrMessage,
  errMessage,
  setSnackOpen,
}) {
  const [addTokenFormData, setAddTokenFormData] = React.useState(
    initialAddTokenFormData,
  );

  const handleAddToken = (event) => {
    const { name, value } = event.target;
    setAddTokenFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddTokenSubmit = async (event) => {
    event.preventDefault();

    try {
      const tokenPayload = {
        name: addTokenFormData.name,
        symbol: addTokenFormData.symbol,
        address: addTokenFormData.address,
        decimals: Number(addTokenFormData.decimals),
      };

      // iconUrl is optional; only send it when provided (the API validates it
      // as a valid http(s) URL and rejects an empty string).
      const iconUrl = addTokenFormData.iconUrl.trim();
      if (iconUrl) tokenPayload.iconUrl = iconUrl;

      const response = await addToken(tokenPayload);
      // Response is an envelope: { success, status, path, data: [...] }
      // Extract token from common shapes
      let token;
      if (Array.isArray(response)) token = response[0];
      else if (response && Array.isArray(response.data))
        token = response.data[0];
      else if (response && response.data && Array.isArray(response.data.data))
        token = response.data.data[0];
      else token = response;

      onTokenAdded(token);
      setAddTokenFormData(initialAddTokenFormData);
      onClose();
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Add token</DialogTitle>
      <DialogContent>
        <form onSubmit={handleAddTokenSubmit}>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              name="name"
              label="Name"
              value={addTokenFormData.name}
              onChange={handleAddToken}
              fullWidth
              required
            />
            <TextField
              name="symbol"
              label="Symbol"
              value={addTokenFormData.symbol}
              onChange={handleAddToken}
              fullWidth
              required
            />
            <TextField
              name="address"
              label="Address"
              value={addTokenFormData.address}
              onChange={handleAddToken}
              fullWidth
              required
            />
            <TextField
              name="decimals"
              label="Decimals"
              type="number"
              value={addTokenFormData.decimals}
              onChange={handleAddToken}
              fullWidth
              required
            />
            <TextField
              name="iconUrl"
              label="Icon URL (optional)"
              type="url"
              placeholder="https://.../icon.png"
              value={addTokenFormData.iconUrl}
              onChange={handleAddToken}
              fullWidth
            />
            <Button type="submit" variant="contained">
              Add token
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
}
